const getShowConflictsModal = state => state.fileConflicts.showConflictsModal;
const getConflictVersions = state => state.fileConflicts.fileVersions;

export default {
  getShowConflictsModal,
  getConflictVersions
};
